import React from "react";
import Icon from "../icons/Icon";
import { IconLibrary } from "../../../interfaces/icon/IconLibrary";
import { IDismissablePillButton } from "../../../interfaces/buttons/buttons";


const DismissablePillButton = ({className, isDisabled, ariaLabel, onButtonClick, content}: IDismissablePillButton) => {
    return (
        <button
            className={`dismissable-pill-style-button ${className ?? ""}`}
            disabled={isDisabled}
            aria-label={ariaLabel}
            onClick={onButtonClick}
        >
            <span>{content}</span>
            <span className="icon-wrapper">
                <Icon iconName={IconLibrary.CLOSE} color="var(--thriveGreyLight)" sizeInPx={"6"}/> 
            </span>
                 
        </button>
    );
};

export default DismissablePillButton